<template>
  <div>
    <my-header></my-header>

    <div class="section-container">
      <side-nav
        :menuItems="menuItems"
        class="side-nav"
      />

      <loading-indicator
        v-if="isLoading"
      />

      <div
        class="content-box"
        v-show="user !== null"
      >
        <h2>{{user | getUserFullName}}</h2>
        <router-view
          @user-data-updated="handleUserDataUpdate"
        />
      </div>
    </div>

  </div>
</template>

<script>
import auth from '../auth';
import { HTTP } from '../http-common';
import { mayReadUserActions as utilMayReadUserActions } from '../util';

import MyHeader from './Header.vue';
import SideNav from './SideNav.vue';
import LoadingIndicator from './LoadingIndicator.vue';
import notifier from '../notifier';

export default {
  name: 'User',

  components: {
    MyHeader,
    SideNav,
    LoadingIndicator,
  },

  props: {
    userId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      actor: auth.getViewer(),

      isLoading: false,
      user: null,
    };
  },

  computed: {
    menuItems() {
      const items = [
        {
          title: 'Info',
          route: {name: 'user_info', params: {userId: this.userId}},
        },
      ];

      if(this.mayReadUserActions) {
        items.push({
          title: 'Actions',
          route: {name: 'user_actions', params: {userId: this.userId}},
        });
      }

      return items;
    },

    mayReadUserActions() {
      return utilMayReadUserActions(this.actor.role);
    },
  },

  watch: {
    userId() {
      this.provideNameInfo();
    },
  },

  created() {
    this.provideNameInfo();
  },

  methods: {
    provideNameInfo() {
      if(this.userId === this.actor.id) {
        this.user = this.actor;
        return;
      }

      this.loadNameInfo();
    },

    loadNameInfo() {
      notifier.deleteSenderNotifications(this);

      this.isLoading = true;

      const url = `/user/${this.userId}/name_info`
      HTTP.get(url)
      .then(response => {
        const data = response.data.data;
        if(data === null) {
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }
        this.user = data;
      })
      .catch(e => {
        notifier.showError(e.response.data, {sender: this});
      })
      .finally(() => {
        this.isLoading = false;
      });
    },

    handleUserDataUpdate(newUserData) {
      const actor = auth.getViewer();
      if(this.userId === actor.id) {
        // already updated
        return;
      }

      this.user.firstName = newUserData.firstName;
      this.user.lastName  = newUserData.lastName;
      this.user.login     = newUserData.login;
    },
  },
}
</script>

<style scoped>
.section-container {
  display: flex;
}

.side-nav {
  margin-right: 3em;
}

.content-box {
  width: 600px;
  padding-top: 1em;
}
</style>
